// Key rules for LogRocket URL and network sanitizing (LP-2622), in the place of lending's PII key rules.
// Deposit uses allowlists instead of lending's PII key lists: a value is recorded only when its name is listed here (and
// the value itself looks harmless, see isSafeValue), so a new or unknown key is masked by default.

/** Query params (compared lower-case) whose values are kept. Every other value is replaced. */
export const SAFE_QUERY_PARAMS = new Set<string>([
    'applicanttype',
    'category',
    'coborrowerflow',
    'code_challenge_method',
    'event',
    'feature',
    'grant_type',
    'institutionid',
    'loanpurpose',
    'redirect',
    'referralcode',
    'response_type',
    'status',
    'subproduct',
    'target',
    'utm_campaign',
    'utm_medium',
    'utm_source',
]);

/** Headers (lower-case) whose values are kept. Everything else (Authorization, cookies, session ids, API keys) is replaced. */
export const SAFE_HEADERS = new Set<string>([
    'accept',
    'accept-language',
    'cache-control',
    'channel',
    'communication-type',
    'content-encoding',
    'content-language',
    'content-length',
    'content-type',
    'flow',
    'institution-id',
    'is-prospect',
    'pragma',
    'product-type',
]);

/**
 * Body keys whose primitive values are kept in requests and responses: statuses, flags, step and product names.
 * Compared after normalizeKey() (lower-case, separators removed). Every other value is replaced.
 */
export const SAFE_BODY_KEYS = new Set<string>([
    'action', 'addedtocore', 'addressusage', 'applicantsstatus', 'applicanttype', 'applicationstatus', 'applicationtype',
    'appofferstatus', 'appstage', 'blocklistflow', 'category', 'channel', 'coapplicantconsentprovided',
    'collateralstatus', 'depositfinalconsent', 'docname', 'documentsstatus', 'documenttype', 'econsent', 'error',
    'expiresin', 'feature', 'finalsubmitchannel', 'granttype', 'groupname', 'hardinquiryconsent',
    'idverificationstatus', 'institutioncode', 'isconditional', 'isprimarysharesavings', 'keyname', 'loanagreementstatus',
    'loanpurpose', 'losstatus', 'mappingscreen', 'marcomconsent', 'maxdepositamount', 'minimumopeningdeposit',
    'offerstatus', 'otprequired', 'otpverifychannel', 'paymentmethod', 'productname', 'producttype', 'reentry',
    'searchotprequired', 'searchsystem', 'selectedindicator', 'softinquiryconsent', 'sourceaccounttype', 'status',
    'statusshortname', 'statusverifymethod', 'stipulationname', 'subproductname', 'subproductsubtype', 'tokentype',
    'underwritingstatus',
]);

/** `code` is a status in responses but an OTP or re-entry token in request bodies, so it is only kept in responses. */
export const SAFE_RESPONSE_ONLY_BODY_KEYS = new Set<string>(['code']);
